'use strict';

exports.__esModule = true;

var _browser = require('./browser');

var _window = require('./window');

var _array = require('./array');

var _logger = require('./logger');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DataLayer = function () {
  function DataLayer(dataLayerName) {
    var _this = this;

    _classCallCheck(this, DataLayer);

    this.dataLayerName = dataLayerName;
    this.dataLayerLog = [];
    this.asyncCommands = [];
    this.loaded = false;
    this.dataLayers = [];

    if (!(0, _array.isArray)(this.dataLayerName)) {
      this.dataLayerName = [this.dataLayerName];
    }
    // This will contain any records that were logged to
    // to the global dataLayer BEFORE traffic was loaded.
    this.dataLayerName.forEach(function (name) {
      var asyncDataLayer = (0, _browser.getWindow)()[name];
      if (asyncDataLayer) {
        var _asyncCommands;

        (_asyncCommands = _this.asyncCommands).push.apply(_asyncCommands, asyncDataLayer);
      }
      // Update the global dataLayer to use this class
      (0, _window.setWindowVar)(name, _this);
      _this.dataLayers.push(asyncDataLayer);
    });
  }

  DataLayer.prototype.start = function start() {
    // Process all records that were added before TCC initialized
    this.loadAsyncCommands();
  };

  DataLayer.prototype.pushLog = function pushLog(cmd) {
    if (process.env.NODE_ENV !== 'production') {
      (0, _logger.debug)('>>> Push to', this.dataLayerName, 'with', cmd);
    }
    (0, _array.logToArray)(this.dataLayerLog, cmd);
  };

  // Abstract


  DataLayer.prototype.process = function process() {};

  DataLayer.prototype.push = function push(cmd) {
    // If the datalayer is not loaded (i.e. the document is not yet loaded), push to the asyncCommands
    if (!this.loaded) {
      this.asyncCommands.push(cmd);
    } else {
      this.process(cmd);
    }
  };

  DataLayer.prototype.loadAsyncCommands = function loadAsyncCommands() {
    while (this.asyncCommands.length > 0) {
      this.process(this.asyncCommands.shift());
    }
    this.loaded = true;
  };

  return DataLayer;
}();

exports.default = DataLayer;